import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as colors from '../../../config/Colors/Ligth';


export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 46px;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h1 {
      font-size: 1.4rem;
      font-weight: bold;
      color: ${colors.titleFontColor};
    }
  }
  div + div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const BodyCadastro = styled.div`
  padding: 20px 0 30px 0;
  border-bottom: 1px solid #eee;
  background-color: 'orange';
  display: flex;
  flex-direction: column;
`;

export const LinkContainer = styled(Link)`
  &:hover {
    filter: brightness(50%);
  }
`;


export const FooterCadastro = styled.div`
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Voltar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -10px;
  a {
    color: ${colors.ligthFontColor};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    p {
      text-transform: uppercase;
    }
    &:hover {
      color: ${colors.titleFontColor};
    }
  }
`;

export const Inline = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
